<template>
  <div>
    <div class="vx-col md:w-2/3 lg:w-full xl:w-2/3 w-full mb-base flex flex-row-reverse">
      <vx-card title="Create Label" >

        <form-wizard ref="wiz" color="rgba(var(--vs-primary), 1)"
                     errorColor="rgba(var(--vs-secondary), 1)"
                     :title="null"
                     :subtitle="null"
                     finishButtonText="Submit"
        >
          <!-- user details tab -->
          <tab-content title="Client Details" class="mb-5" icon="feather icon-user" :before-change="validateUser">

            <!-- user details tab -->
            <form data-vv-scope="step-1">
              <div v-show="!show.newUser" class="vx-row mb-6">
                <div class="vx-col w-2/3">
                  <UserSearch @selected="setUser"

                              :selectedUser="user"
                              placeholder="Search by name, email or postcode"
                              label="Existing Client"
                              helpText="Associate document with an existing client."/>
                </div>
              </div>

              <div v-show="show.newUser" class="mb-6">

                <div class="vx-row mb-6">
                  <div class="vx-col w-full">
                    <vs-input class="w-full"
                              :danger="!!errors.email"
                              :danger-text="errors.email"
                              icon-pack="feather" icon="icon-mail" icon-no-border
                              label="Email"
                              v-model="form.new_user.email" />
                  </div>
                </div>

                <div class="vx-row mb-6">
                  <div class="vx-col w-full">
                    <vs-input class="w-full"
                              :danger="!!errors.full_name"
                              :danger-text="errors.full_name"
                              icon-pack="feather" icon="icon-user" icon-no-border
                              label="Full Name"
                              v-model="form.new_user.full_name" />
                  </div>
                </div>

                <div class="vx-row mb-6">
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full"
                              :danger="!!errors.address_line_1"
                              :danger-text="errors.address_line_1"
                              icon-pack="feather" icon="icon-map-pin" icon-no-border
                              label="Address Line 1"
                              v-model="form.new_user.address_line_1" />
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full"
                              :danger="!!errors.address_line_2"
                              :danger-text="errors.address_line_2"
                              icon-pack="feather" icon="icon-map-pin" icon-no-border
                              label="Address Line 2"
                              v-model="form.new_user.address_line_2" />
                  </div>
                </div>

                <div class="vx-row mb-6">
                  <div class="vx-col w-2/3">
                    <vs-input class="w-full"
                              :danger="!!errors.post_town"
                              :danger-text="errors.post_town"
                              icon-pack="feather" icon="icon-map-pin" icon-no-border
                              label="Post Town"
                              v-model="form.new_user.post_town" />
                  </div>
                  <div class="vx-col w-1/3">
                    <vs-input class="w-full"
                              :danger="!!errors.post_code"
                              :danger-text="errors.post_code"
                              icon-pack="feather" icon="icon-map-pin" icon-no-border
                              label="Post Code"
                              v-model="form.new_user.post_code" />
                  </div>
                </div>

                <div class="vx-row mb-6">
                  <div class="vx-col w-1/2">
                   <CountrySelect @selected="setCountry" :selected-country="country"  :danger-text="errors.country" />
                  </div>
                  <div class="vx-col w-1/2">

                    <vs-input class="w-full"
                              :danger="!!errors.phone"
                              :danger-text="errors.phone"
                              icon-pack="feather" icon="icon-phone" icon-no-border
                              label="Phone"
                              v-model="form.new_user.phone" />
                  </div>
                </div>

              </div>
            </form>
            <vs-divider></vs-divider>
            <div class="flex ">
              <vs-button iconPack="feather" icon="icon-user" color="primary" @click="switchUserCreation">{{ show.newUser ? 'Select existing client' : 'Create new client'}}</vs-button>
            </div>
          </tab-content>
          <!-- document details tab -->
          <tab-content title="Document Details" class="mb-5" icon="feather icon-file-text" :before-change="validateDoc">
            <form data-vv-scope="step-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Document Type</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full ml-auto">
                  <vs-checkbox class="inline-flex" v-model="form.will">Will</vs-checkbox>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-2/3 w-full ml-auto">
                  <vs-checkbox class="inline-flex" v-model="form.trust">Trust</vs-checkbox>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-2/3 w-full ml-auto">
                  <vs-checkbox class="inline-flex" v-model="form.lpa">LPA</vs-checkbox>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-2/3 w-full ml-auto">
                  <vs-checkbox class="inline-flex" v-model="form.property_deeds">Property Deeds</vs-checkbox>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Document Signed Date</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input v-model="form.signed_date" type="date"></vs-input>
                  <div class="con-text-validation span-text-validation vs-input--text-validation-span">
                    <span class="span-text-validation">Associate this document with a user.</span>
                  </div>
                </div>
              </div>
            </form>
          </tab-content>

        </form-wizard>

      </vx-card>
    </div>

    <h4 class="mb-4">Recently created</h4>
    <div id="data-list-list-view"
            class="data-list-container"
            v-if="documents">
        <RecentlyCreateTable :data="documents" @update="getPage"></RecentlyCreateTable>
    </div>

  </div>
</template>

<script>
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import UserSearch from "@/components/common/UserSearch"
  import { textFormat } from '@/mixins/textFormat'
  import { http } from '@/services'
  import * as JsPDF from 'jspdf'

  import RecentlyCreateTable from './table.vue'

  import CountrySelect from "../../../components/common/CountrySelect";

  export default {
    name: 'StoreDocument',
    mixins: [textFormat],
    mounted () {
      this.getPage()
    },
    components: {
      UserSearch,
      CountrySelect,
      RecentlyCreateTable
    },
    data () {
      return {
        form: {
          will: false,
          lpa: false,
          trust: false,
          property_deeds: false,
          signed_date: null,
          user: null,
          new_user: {
            email: null,
            full_name: null,
            address_line_1: null,
            address_line_2: null,
            post_town: null,
            post_code: null,
            country: null,
            phone: null
          }
        },
        user: null,
        country: null,
        show: {
          newUser: false
        },
        errors: {
          email: null,
          full_name: null,
          address_line_1: null,
          address_line_2: null,
          post_town: null,
          post_code: null,
          country: null,
          phone: null,
        },
        documents: null,
        selected: []
      }
    },
    computed: {
      recent () {
        return this.$store.getters.recentCreatedDocuments
      }
    },
    methods: {
      clearNewUser () {
        this.form.new_user.email = null
        this.form.new_user.full_name = null
        this.form.new_user.address_line_1 = null
        this.form.new_user.address_line_2 = null
        this.form.new_user.post_town = null
        this.form.new_user.post_code = null
        this.form.new_user.country = null
        this.form.new_user.phone = null
        this.country = null
      },
      switchUserCreation () {
        if (this.show.newUser) {
          this.clearNewUser()
          this.clearNewUserErrors()
        } else {
          this.form.user = null
          this.user = null
        }
        this.show.newUser=!this.show.newUser
      },
      async createNewUser () {
        this.clearNewUserErrors()
        return new Promise( (resolve, reject) => {
          http.post('create_new_user', this.form.new_user).then(
        response => {
          this.$vs.notify({
            title:'Success',
            text:'User created',
            color:'success'
          })
          this.clearNewUser()
          this.form.user = response.data.id
          this.user = {value: response.data.id, label: `${response.data.email} - ${response.data.user_detail.full_name}`}
          this.show.newUser = false
          resolve(true)
        }
        ).catch(
        errors => {
          this.handleNewUserErrors(errors.response.data)
          reject(false)
        }
        )
      })
      },
      validateUser () {
        return new Promise((resolve, reject) => {
          if (this.form.user && !this.form.new_user.email) resolve(true)
          else if (this.show.newUser) {
            this.createNewUser().then(response => {
              resolve(true)
            }
            ).catch(
            error => {
              reject(true)
            }
            )
          }
          else reject("correct all values");
        })
      },
      validateDoc () {
        return new Promise((resolve, reject) => {
          http.post('document_detail', this.form).then(
          response => {
            this.resetForm()
            this.getPage()
            resolve(true)
          }
          ).then(response => {
            this.$vs.notify({
              title:'Success',
              text:'Document reference created',
              color:'success'
            })
            this.$refs.wiz.reset()
          }
          ).catch(
          error => {
            console.log(error)
            reject(true)
          }
          )
        })
      },
      handleNewUserErrors (errors) {
        if (errors.email) this.errors.email = errors.email[0]
        if (errors.full_name) this.errors.full_name = errors.full_name[0]
        if (errors.address_line_1) this.errors.address_line_1 = errors.address_line_1[0]
        if (errors.address_line_2) this.errors.address_line_2 = errors.address_line_2[0]
        if (errors.post_town) this.errors.post_town = errors.post_town[0]
        if (errors.post_code) this.errors.post_code = errors.post_code[0]
        if (errors.country) this.errors.country = errors.country[0]
        if (errors.phone) this.errors.phone = errors.phone[0]
      },
      clearNewUserErrors () {
        this.errors.email = null
        this.errors.full_name = null
        this.errors.address_line_1 = null
        this.errors.address_line_2 = null
        this.errors.post_town = null
        this.errors.post_code = null
        this.errors.country = null
        this.errors.phone = null
      },
      setUser (value) {
        this.user = value
        if (value && value.id) this.form.user = value.id
        else this.form.user = null
      },
      setCountry (value) {
        this.country = value
        if (value && value.value) this.form.new_user.country = value.value
        else this.form.new_user.country = null
      },
      resetForm () {
        this.form.will = false
        this.form.lpa = false
        this.form.trust = false
        this.form.property_deeds = false
        this.form.signed_date = null
        this.form.user = null
        this.user = null
        this.country = null
        this.clearNewUser()
      },
      getPage (searchQuery = null) {
        http.get('paper_documents_list', { params: { filter: 'created_recently', items_per_page: 1000, page_number: 1, sort: ['date_created', 'desc'] } }).then(
        response => {
          this.documents = response.data
        }
        ).catch(
        error => {
          console.log(error)
        }
        )
      },
      markAllAndMarkAsSent () {
        this.selected = this.documents.data
        this.markSentToStorage()
      }
    }
  }
</script>

<style >
  .stepTitle {
    color: white !important;
  }
</style>
